import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { getToken } from '../../../../helpers/Jwt';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faClose, faSign, faSignHanging, faSignIn, faSignLanguage, faSignature, faSigning } from '@fortawesome/free-solid-svg-icons';
import ModalSign from '../../component/ModalSign/ModalSign';
import BadgeStatus from '../../component/BadgeStatus/BadgeStatus';
import { confirmDelete } from '../../../../helpers/PromptUtils';

const DetailReservation = () => {
    const { id } = useParams();

    const [error, setError] = useState(null);

    const [detailData, setDetailData] = useState(null);
    const [isModalSign, setModalSign] = useState(false);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_RESERVATION = "api/kejati/dashboard/reservation";

    const fetchData = async (url, headers) => {
        try {
            const response = await axios.get(url, { headers });
            return response.data;
        } catch (err) {
            setError("Gagal memuat data. Silakan coba lagi.");
            console.error(err);
            return null;
        }
    };

    const handleApprove = async () => {
        if (detailData?.status != 'pending') {
            alert(`Status Data ${detailData?.status}.`);
            return;
        }
        try {
            const response = await axios({
                method: "POST",
                url: `${BASE_URL}${PATH_RESERVATION}/approve`,
                data: { id },
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                    "Content-Type": "application/json"
                }
            });

            const { message } = response.data;

            alert(message);
            window.location.reload();
        } catch (error) {
            alert(error)
        }
    }

    const handleCancel = async (rowData) => {
        if (detailData?.status != 'pending') {
            alert(`Status Data ${detailData?.status}.`);
            return;
        }
        const confirmed = confirmDelete('Yakin Batalkan Reservasi ini?');
        if (confirmed) {
            try {
                const response = await axios({
                    method: "POST",
                    url: `${BASE_URL}${PATH_RESERVATION}/cancel`,
                    data: { id },
                    headers: {
                        Authorization: `Bearer ${getToken()}`,
                        "Content-Type": "application/json"
                    }
                });

                const { message } = response.data;

                alert(message);
                window.location.reload();
            } catch (error) {
                alert(error)
            }
        }
    }

    const handleSign = async () => {
        setModalSign(true);
    }

    useEffect(() => {
        if (id) {
            fetchData(`${BASE_URL}${PATH_RESERVATION}/detail?id=${id}`, {
                Authorization: `Bearer ${getToken()}`,
                "Content-Type": "application/json"
            }).then((detail) => {
                setDetailData(detail);
            });
        }
    }, [id]);

    const statusColor = (status) => {
        switch (status) {
            case 'pending':
            case 'signed':
                return 'info';
            case 'approved':
                return 'warning';
            case 'canceled':
                return 'error';
            case 'default':
                break;
        }
        return 'default';
    }

    const statusText = (status) => {
        switch (status) {
            case 'pending':
                return "Menunggu Persetujuan";
            case 'approved':
                return "Disetujui";
            case 'queue':
                return 'Antre';
            case 'canceled':
                return 'Dibatalkan';
            case 'signed':
                return 'Sudah Serah Terima';
            case 'default':
                break;
        }
        return status;
    }

    return (
        <div className="font-sans p-6 min-h-screen">
            <ModalSign
                show={isModalSign}
                onClose={() => setModalSign(false)}
                signedName1={"Operator PTSP"}
                signedName2={"Yang Menerima"}
                onChange={async (value) => {
                    try {
                        const response = await axios({
                            method: "POST",
                            url: `${BASE_URL}${PATH_RESERVATION}/sign`,
                            data: {
                                id,
                                image_signature_given: value.x,
                                image_signature_received: value.y
                            },
                            headers: {
                                Authorization: `Bearer ${getToken()}`,
                                "Content-Type": "application/json"
                            }
                        });

                        const { message } = response.data;

                        alert(message);
                        window.location.reload();
                    } catch (error) {
                        alert(error)
                    }
                }} />
            <div className='flex justify-between'>
                <h1 className="text-2xl font-bold text-gray-800 mb-6">Data Detail</h1>
            </div>
            <div className='p-3 rounded-lg shadow-md bg-white'>
                <div className='flex justify-between'>
                    <div className="px-3">
                        <img src={`${BASE_URL}/upload/kejati/${detailData?.qrcode}`} alt="QR-Code" className="max-w-full h-auto mt-1" />
                        <b className="text-gray-800 mx-5">{detailData?.code}</b>
                    </div>
                    <div>
                        <BadgeStatus text={statusText(detailData?.status)} status={() => statusColor(detailData?.status)} />
                    </div>
                </div>
                <hr className='m-5' />
                <div className='px-5 py-3'>
                    {detailData?.status == 'pending' ? <>
                        <button disabled={detailData?.status == 'pending' ? false : true} onClick={handleApprove} type='button' className='text-white text-xs rounded focus:ring bg-green-500 hover:bg-green-700 p-2 mx-1'>
                            <FontAwesomeIcon icon={faCheck} color="white" /> Terima Reservasi
                        </button>
                        <button disabled={detailData?.status == 'pending' ? false : true} onClick={handleCancel} type='button' className='text-white text-xs rounded focus:ring bg-red-500 hover:bg-red-700 p-2 mx-1'>
                            <FontAwesomeIcon icon={faClose} color="white" /> Batalkan
                        </button>
                    </> : <></>}

                    {detailData?.status != 'signed' ? <>
                        <button onClick={handleSign} type='button' className='text-white text-xs rounded focus:ring bg-yellow-500 hover:bg-yellow-700 p-2 mx-1'>
                            <FontAwesomeIcon icon={faSignature} color="white" /> Serahkan Berkas/Barang
                        </button>                        
                    </> : <></>}
                </div>
                {detailData?.status == 'pending' || detailData?.status == 'approved' ? <hr className='m-5' /> : <></>}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 px-3">
                    <div className="px-3">
                        <strong className="block text-gray-600">Name:</strong>
                        <p className="text-gray-800">{detailData?.name}</p>
                    </div>
                    <div className="px-3">
                        <strong className="block text-gray-600">NIK:</strong>
                        <p className="text-gray-800">{detailData?.nik}</p>
                    </div>
                    <div className="px-3">
                        <strong className="block text-gray-600">Description:</strong>
                        <p className="text-gray-800">{detailData?.description}</p>
                    </div>
                    <div className="px-3">
                        <strong className="block text-gray-600">Date:</strong>
                        <p className="text-gray-800">{detailData?.date}</p>
                    </div>
                    <div className="px-3">
                        <strong className="block text-gray-600">Time:</strong>
                        <p className="text-gray-800">{detailData?.time}</p>
                    </div>
                    <div className="px-3">
                        <strong className="block text-gray-600">Service:</strong>
                        <p className="text-gray-800">{detailData?.service}</p>
                    </div>
                    <div className="px-3">
                        <strong className="block text-gray-600">Unit Kerja:</strong>
                        <p className="text-gray-800">{detailData?.unit_kerja_name}</p>
                    </div>
                    <div className="px-3">
                        <strong className="block text-gray-600">WhatsApp:</strong>
                        <p className="text-gray-800">{detailData?.whatsapp}</p>
                    </div>
                    <div className="px-3">
                        <strong className="block text-gray-600">Nomor Berkas:</strong>
                        <p className="text-gray-800">{detailData?.traffic_ticket}</p>
                    </div>
                </div>

                <hr className='my-5' />

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 px-3">
                    {/* Berkas */}
                    <div className="px-3">
                        <strong className="block text-gray-600">Berkas</strong>
                        <div className="border-2 border-gray-300 rounded-xl shadow-sm overflow-hidden p-4 flex items-center gap-4">
                            {detailData?.file ? (
                                <div className="flex flex-col items-start">
                                    <div className="text-sm text-gray-700 mb-2">{detailData.file}</div>
                                    <a
                                        href={`${BASE_URL}/upload/${detailData.file}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="inline-block px-3 py-1 text-sm bg-blue-500 text-white rounded hover:bg-blue-600 transition"
                                    >
                                        Lihat / Unduh Berkas
                                    </a>
                                </div>
                            ) : (
                                <div className="text-gray-500 text-sm">Tidak ada berkas tersedia</div>
                            )}
                        </div>
                    </div>

                    {detailData?.service == "Jemput Tilang" ? (
                        <div className="px-3">
                            <strong className="block text-gray-600">Foto Tilang</strong>
                            <div className="border-2 border-gray-300 rounded-xl shadow-sm overflow-hidden">
                                <img
                                    className="object-cover max-w-48 h-auto mt-2"
                                    src={`${BASE_URL}/upload/${detailData?.image_traffic_ticket}`}
                                    alt="Foto Surat Tilang"
                                />
                            </div>
                        </div>
                    ) : null}


                    {detailData?.service == "Jemput Tilang" ? (
                        <div className="px-3">
                            <strong className="block text-gray-600">Foto Bukti Bayar Tilang</strong>
                            <div className="border-2 border-gray-300 rounded-xl shadow-sm overflow-hidden">
                                <img
                                    className="object-cover max-w-48 h-auto mt-2"
                                    src={`${BASE_URL}/upload/${detailData?.image_proof_payment}`}
                                    alt="Foto Bukti Bayar"
                                />
                            </div>
                        </div>
                    ) : null}
                </div>


                <hr className='my-5' />

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 px-3">
                    <div className="px-3">
                        <strong className="block text-gray-600">Operator PTSP</strong>
                        <div className='border-2 border-gray-300 rounded-xl shadow-sm overflow-hidden'>
                            <img className="object-cover  max-w-48 h-auto mt-2" src={`${BASE_URL}/upload/kejati/${detailData?.image_signature_given}`} alt="Proof of Payment" />

                        </div>
                    </div>
                    <div className="px-3">
                        <strong className="block text-gray-600">Yang Menerima</strong>
                        <div className='border-2 border-gray-300 rounded-xl shadow-sm overflow-hidden'>
                            <img className="object-cover max-w-48 h-auto mt-2" src={`${BASE_URL}/upload/kejati/${detailData?.image_signature_received}`} alt="Proof of Payment" />

                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default DetailReservation;